import React, { Component } from 'react'
import { connect } from 'react-redux'

import TextField from 'material-ui/TextField'
import MenuItem from 'material-ui/MenuItem'
import Moment from 'moment'

import StatusIcon from '../properties/StatusIcon'
import Select from 'components/Select'
import Checkbox from 'material-ui/Checkbox'
import Chip from 'material-ui/Chip'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead, currentDate } from 'selectors/common'
import { propertiesEx } from 'selectors/properties'
import { getMonth, getTimezoneDate } from 'utils/date'

let select = dirtyRead(
	(state, props) => ({
		property: doc(state, props.propertyID)
	  , events: propertiesEx(state)[props.propertyID]
  	  , currentDate: currentDate(state)
	})
)

export class StatusSelect extends Component{
	render(){
		let { props } = this
		return(
			<div>
				{props.events && props.events.status && props.events.status.forRent!='For Rent' && props.events.status.contracted!=='Contracted' && props.events.status.occupied!='Occupied' && !props.property.dateTill && <Chip
					style={{
						background: "orange"
					  , marginLeft: "40px"
					  , display: "inline-block"
					}}
				>
				  Not in Service
				</Chip>}
				{props.events && props.events.status && props.events.status.forRent=='For Rent' && !props.property.dateTill && <Chip
					style={{
						background: "rgb(200,200,255)"
					  , marginLeft: "40px"
					  , display: "inline-block"
					}}
				>
				  For rent
				</Chip>}
				{props.events && props.events.status && props.events.status.occupied=='Occupied' && !props.property.dateTill  && <Chip
					style={{
						background:"green"
					  , marginLeft:props.events.status.forRent=='For Rent'?"20px":"40px"
					  , display: "inline-block"
					}}
				>
				  Occupied
				</Chip>}
				{props.events && props.events.status && props.events.status.contracted=='Contracted' && !props.property.dateTill  && <Chip
					style={{
						background: "green"
					  , marginLeft: props.events.status.occupied=='Occupied'?"20px":"40px"
					  , display: "inline-block"
					}}
				>
				  	Contracted
				</Chip>}
				{props.events && props.events.status && props.events.status.occupied=='Occupied' && !props.property.dateTill  && !props.events.status.paid && <Chip
					style={{
						background:!props.events.status.paid ? "red" : "rgb(200,255,200)"
					  , marginLeft: "20px"
					  , display: "inline-block"
					}}
				>
					Not paying
				</Chip>}
				{props.property && props.property.dateTill && <Chip
					onRequestDelete={() =>{props.STAGE({_id: props.propertyID, dateTill: undefined})}}
					key={props.property.dateTill}
					backgroundColor="red"
					style={{
						background:"red"
					  , marginLeft:"40px"
					  , color: "white"
					}}
				>
				  Retired {(getTimezoneDate(props.property.dateTill).getDate()>9?getTimezoneDate(props.property.dateTill).getDate():('0'+getTimezoneDate(props.property.dateTill).getDate()))+' '+getMonth(getTimezoneDate(props.property.dateTill).getMonth())+' '+getTimezoneDate(props.property.dateTill).getFullYear()%100}
				</Chip>}
			</div>
		)
	}
}

export default connect(select, dataActions)(StatusSelect)


//<div className="status-select" style={{display:"flex"}}>
//	<div style={{marginTop: "13px"}}>

//	</div>



// WEBPACK FOOTER //
// ./src/routes/manager/propertyForm/StatusSelect.js